import gql from 'graphql-tag';

export const PageHeaderLoomButtonQuery = gql`
	query PageHeaderLoomButtonQuery($contentId: ID!) {
		contentContributors(id: $contentId) {
			isCurrentUserContributor
		}
		content(id: $contentId, status: ["current", "draft"]) {
			nodes {
				id
				operations {
					operation
					targetType
				}
				history {
					ownedBy {
						... on KnownUser {
							accountId
						}
					}
				}
			}
		}
	}
`;
